// Shared formatters for live-data widgets. Centralized so the same number /
// percent / date format applies everywhere, and the v1 port doesn't drift.

const usd0 = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
});

const usd2 = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

const intFmt = new Intl.NumberFormat("en-US");

export function formatCurrency0(value: number | null | undefined): string {
    if (value == null) return "-";
    return usd0.format(value);
}

export function formatCurrency2(value: number | null | undefined): string {
    if (value == null) return "-";
    return usd2.format(value);
}

export function formatInt(value: number | null | undefined): string {
    if (value == null) return "-";
    return intFmt.format(Math.round(value));
}

export function formatPercent(value: number | null | undefined): string {
    // Inputs in 0..1 (e.g., 0.78 → 78%).
    if (value == null) return "-";
    return `${Math.round(value * 100)}%`;
}

export function formatGeneratedAt(iso: string): string {
    try {
        const d = new Date(iso);
        return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    } catch {
        return iso;
    }
}
